import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import Base from '../../_config/base';

class Impressionen extends Base {
  constructor(el) {
    super(el);
    const slider = document.querySelector('.swiper');
    const sliderClose = document.querySelector('.impressionen__slider__close');
    const sliderWrapper = document.querySelector('.impressionen__slider');
    const galeryImgs = [...el.querySelectorAll('.impressionen__galery__img')];

    const sliderOpt = {
      // configure Swiper to use modules
      modules: [Navigation],
      centeredSlides: true,
      slidesPerView: 1,
      spaceBetween: 48,
      // pagination: {
      //   el: '.swiper-pagination',
      //   clickable: true,
      // },
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    };

    // eslint-disable-next-line
    const swiper = new Swiper(slider, sliderOpt);

    galeryImgs.forEach((galeryImg) => {
      galeryImg.onclick = () => {
        document.querySelector('header')?.classList.add('z-index-0');
        document.querySelector('body')?.classList.add('overflow-hidden');
        sliderWrapper.classList.remove('d-none');
        swiper.slideTo(galeryImgs.indexOf(galeryImg), 0);
      };
    });

    sliderClose.onclick = () => {
      document.querySelector('body')?.classList.remove('overflow-hidden');
      document.querySelector('header')?.classList.remove('z-index-0');
      sliderWrapper.classList.add('d-none');
    };
  }
}

Impressionen.className = 'Impressionen';
export default Impressionen;
